export default {
  audioPath: '//eagleeye.italent.cn/Images/bg.mp3',
  worldShader: '//eagleeye.italent.cn/Images/world-bg-v2.png',
  smokeBg: '//eagleeye.italent.cn/Images/smoke-v2.png'
}


// WEBPACK FOOTER //
// ./src/utils/static-path/index.js